/* eslint-disable react/require-default-props */
import React from 'react';
import SectionCard from 'components/organisms/section_card';

const normalizeItems = (items?: string[] | string) => {
  if (!items) return [];

  if (typeof items === 'string') {
    return [items];
  }

  return items;
};

const List = ({ items }: { items?: string[] | string }) => {
  const normalized = normalizeItems(items);

  if (!normalized.length) return null;

  return (
    <ul className="mt-2 mb-3 pl-4">
      {normalized.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

const Section = ({ title, items }: { title: string; items?: string[] | string }) => {
  const normalized = normalizeItems(items);

  if (!normalized.length) return null;

  return (
    <div className="mt-3">
      <strong className="d-block">{title}</strong>
      <List items={normalized} />
    </div>
  );
};

const AnnotationsSection = ({ data }: any) => {
  if (!data) return null;

  return (
    <SectionCard title="Anotações" icon="description">
      <p>As anotações feitas nessa licitação são referentes à:</p>

      <Section title="Pendências" items={data?.pendencias} />
      <Section title="Pontos de atenção" items={data?.pontos_atencao} />
      <Section title="Decisões internas" items={data?.decisoes} />
    </SectionCard>
  );
};

export default AnnotationsSection;
